// <fiee-idle> returns the kiosk to its home screen when nobody has touched it
// for a while (view/panel_layout.templ).
//
// A public screen must not keep the previous visitor on display: an open
// announcement, a half-read map, or — worst — a ChatBot conversation about
// their grades or debts. The server expires the chat session on its own, but
// nothing would ever clear what is already on the glass. On idle this island:
//
//   - on the ChatBot page, ends the visit first (POST to the "Terminar
//     consulta" endpoint, which deletes the session and its messages);
//   - anywhere else away from home, navigates to the home screen;
//   - on the home screen, just closes the dialog and scrolls back to the top.
//
// Attributes: seconds (default 120), home (default "/panel"), end (the POST
// endpoint that ends a chat visit).
export class FieeIdle extends HTMLElement {
  #timer = 0;
  #reset = () => this.#arm();
  static #events = ["pointerdown", "keydown", "wheel", "scroll", "input"];

  connectedCallback() {
    for (const name of FieeIdle.#events) {
      window.addEventListener(name, this.#reset, { passive: true, capture: true });
    }
    this.#arm();
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    for (const name of FieeIdle.#events) {
      window.removeEventListener(name, this.#reset, { capture: true });
    }
  }

  #arm() {
    window.clearTimeout(this.#timer);
    const seconds = Number(this.getAttribute("seconds")) || 120;
    this.#timer = window.setTimeout(() => void this.#idle(), seconds * 1000);
  }

  async #idle() {
    const home = this.getAttribute("home") || "/panel";
    const end = this.getAttribute("end");
    const here = location.pathname.replace(/\/$/, "") || "/";

    if (end && here.startsWith("/panel/chatbot")) {
      try {
        await fetch(end, { method: "POST", redirect: "manual" });
      } catch {
        // The server expires the session anyway; leaving the page is what
        // matters for the person walking up next.
      }
    }

    if (here === home.replace(/\/$/, "")) {
      document.querySelector<HTMLDialogElement>("dialog[open]")?.close();
      document.querySelector(".panel-main")?.scrollTo({ top: 0, behavior: "smooth" });
      this.#arm();
      return;
    }
    location.assign(home);
  }
}
